@if (label()) {
  <div class="rich-textarea-label">{{ label() }}</div>
}
<neo-form-rich-text-froala
  [ngModel]="value"
  (ngModelChange)="onValueChange($event)"
  [attr.aut-id]="autId()"
  [config]="config()"
  [caption]="''"
  [ariaLabel]="accessibleName()"
/>
